var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05893 2.05448C4.79801 -0.684824 9.23892 -0.684828 11.978 2.05448L26.6255 16.7032L41.273 2.05448C44.0121 -0.684819 48.453 -0.684825 51.1921 2.05448C53.9311 4.79378 53.9312 9.23508 51.1921 11.9744L36.5446 26.6231L51.1967 41.2765C53.9358 44.0158 53.9358 48.4571 51.1967 51.1964C48.4576 53.9357 44.0167 53.9357 41.2777 51.1964L26.6255 36.543L11.9734 51.1964C9.2343 53.9357 4.79338 53.9357 2.0543 51.1964C-0.684767 48.4571 -0.684769 44.0158 2.0543 41.2765L16.7064 26.6231L2.05893 11.9744C-0.68014 9.23508 -0.680138 4.79378 2.05893 2.05448Z",
    fill: "#889BD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCross);
export default __webpack_public_path__ + "static/media/blue-cross.8705c24bb7bb5e14c1c1f016a954dc17.svg";
export { ForwardRef as ReactComponent };